import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_sidebar/observer')({
  component: CertificationEntityLayout,
})

function CertificationEntityLayout() {
  return <Outlet />
}

